import { FaTrash } from "react-icons/fa";

const AdminTrendingLinkCard = ({ handleLinkDelete, id, link, imageUrl }) => {
  return (
    <div
      className="card has-background-success-light"
      style={{ width: "100%", textAlign: "center" }}
    >
      <div className="card-image">
        <figure className="image is-square">
          <img
            style={{
              width: "100%",
              objectFit: "scale-down",
            }}
            src={imageUrl}
            alt="Resource"
          />
        </figure>
      </div>

      <div className="card-content">
        <div className="media">
          <div className="media-content">
            <h1 className="title is-4">{link}</h1>
          </div>
        </div>
      </div>
      <footer className="card-footer">
        <button
          className="button card-footer-item"
          onClick={() => handleLinkDelete(id)}
        >
          <FaTrash color="tomato" />
        </button>
      </footer>
    </div>
  );
};

export default AdminTrendingLinkCard;
